import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { Environment } from '../../../shared/environment';

interface ItensImpr {
  descricao: string;
  quantidade: number;
 };
 
 export interface IgetImpressaoNota {
   idtalao: string;
   numero: string;
   datalan: Date;
   nome: string;
   cpf: string;
   rg: string;
   fantasia: string;
   endereco: string;
   bairro: string;
   municipio: string;
   uf: string;
   celular: string;
   logo: string;
   cep: string;
   itens: ItensImpr[];
 }
  
async function PDFTalao(dados: IgetImpressaoNota){

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  
    async function getBase64ImageFromUrl(url: string): Promise<string> {
      return new Promise((resolve, reject) => {
        const img: HTMLImageElement = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
          const canvas: HTMLCanvasElement = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            reject('Não foi possível obter o contexto 2D');
            return;
          }
          const image = this as HTMLImageElement;
          canvas.height = image.naturalHeight;
          canvas.width = image.naturalWidth;
          ctx.drawImage(image, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = function () {
          reject(`Não foi possível carregar a imagem de ${url}`);
        };
        img.src = url;
      });
    }
  
    const imageUrl = Environment.URL_IMGFABRICA + dados.logo || '';
    const imageData = await getBase64ImageFromUrl(imageUrl);
  
    if (!imageData.startsWith('data:image')) {
      return new Error('A imagem não foi convertida corretamente para base64.');
    }
  
    const rows = dados.itens.map((row) => {
      return [

        { text: row.descricao, fontSize: 8, },

        {
          text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.quantidade),
          alignment: 'right',  bold: true, fontSize: 9
        },
      ]
    });
  
    const documentDefinition: any = {
  
      content: [
        {
          style: 'tableExample',
          table: {
            margin: [0, 0, 0, 0],
            widths: [80, 230, 3, 70, 3, 88],
            body: [   
              [
                {
                  margin: [0, 2, 0, 0],  
                  image: imageData,
                  width: 50,
                  alignment: 'center',
                  border: [true, true, false, true],
                },
                {
                  border: [false, true, true, true],
                  table: {
                    widths: [200],
                    body: [
                      [
                        { text: 'Av. Sete Setembro, 106 Sala 401  São Bento', fontSize:10, alignment: 'center',
                           border: [false, false, false, false] },
                      ],
                      [
                        { text: 'Fone: (71) 32667138, 9984-9999', alignment: 'center', border: [false, false, false, false], fontSize: 9, },
                       ],
                      [
                        { text: 'CEP 40.060-001  Salvador  Ba', alignment: 'center', 
                          fontSize: 9, border: [false, false, false, false] },
                      ],
                    ],  
  
                  }
                },
                { text: '', bold: true, border: [false, false, false, false] },
                {
                  table: {
                    widths: [70],
                    body: [
                      [
                        { text: 'PEDIDO', fontSize: 14, bold: true, alignment: 'center',
                           border: [false, false, false, false] },
                      ],
                      [
                        { text: 'Nº '+dados.numero, alignment: 'left', bold: true,
                          border: [false, false, false, false], fontSize: 12, },
                      ],
                    ],
  
                  }
                },
                { text: '', bold: true, border: [false, false, false, false] },
                {
                  table: {
                    widths: [70],
                    body: [
                      [
                        { text: 'Vendedor:', fontSize: 12,  alignment: 'Left',
                           border: [false, false, false, false] },
                      ],
                      [
                        { text:  moment(dados.datalan).format('DD/MM/YYYY'), alignment: 'Left', border: [false, false, false, false], fontSize: 9, },
                      ],
                    ],
  
                  }
                }
              ],
            ]
          }
        },
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: [250, 260],
            body: [
              [   
                { text: 'Razão Social', fontSize: 8, bold: true, border: [true, true, false, false] },
                { text: 'Nome Fantasia', fontSize: 8, border: [false, true, true, false] },
              ],
              [
                { text: dados.nome, fontSize: 9, border: [true, false, false, true] },
                { text: dados.fantasia, fontSize: 9, border: [false, false, true, true] },
              ]
            ],
          }
        },    
        {
          table: {
            widths: [150, 90, 261], 
            body: [
              [   
                { text: 'CPF/CNPJ:', fontSize: 8, bold: true, border: [true, false, false, false] },
                { text: 'RG/I.E:', fontSize: 8, border: [false, false, false, false] },
                { text: 'Endereço:', fontSize: 8, border: [false, false, true, false] },
              ],
              [
                { text: dados.cpf, fontSize: 9, border: [true, false, false, true] },
                { text: dados.rg, fontSize: 9, border: [false, false, false, true] },
                { text: dados.endereco, fontSize: 9, border: [false, false, true, true] },
              ]
            ],
          }
        }, 
        {
          table: {
            widths: [150, 160, 60, 122], 
            body: [
              [   
                { text: 'Bairro:', fontSize: 8, bold: true, border: [true, false, false, false] },
                { text: 'Cidade - UF:', fontSize: 8, border: [false, false, false, false] },
                { text: 'CEP:', fontSize: 8, border: [false, false, false, false] },
                { text: 'Telefone:', fontSize: 8, border: [false, false, true, false] },
              ],
              [
                { text: dados.bairro, fontSize: 9, border: [true, false, false, true] },
                { text: dados.municipio+'-'+dados.uf, fontSize: 9, border: [false, false, false, true] },
                {text: (dados.cep !== null ? (
                  dados.cep.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})/, '$1.$2-$3')
                ) : (
                 ''
                )), fontSize: 10, alignment: 'left', border: [false, false, false, true]  }, 
                {text: dados.celular, fontSize: 10, alignment: 'left', border: [false, false, true, true]},
              ]
            ],
          }
        },   
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: [440, 70],
            body: [
              [
                { text: 'Descrião', fontSize: 9 },
                { text: 'Quantidade', alignment: 'center',  fontSize: 9 },
              ],  
              ...rows,
            ]
          },
        },
        {
          margin: [30, 30, 0, 0],
          table: {
            widths: [150, 100, 150],
            body: [
              [
                { text: 'Ass. Comprador', alignment: 'center', fontSize: 9, border: [false, true, false, false] },
                { text: '', fontSize: 9, border: [false, false, false, false] },
                { text: 'Vendedor', alignment: 'center', border: [false, true, false, false],  fontSize: 9 },
              ],  
            ]
          },
        },
        {
          margin: [15, 5, 0, 0],
          table: {
            widths: [150, 300],
            body: [
              [
                { text: 'Data Entrega ______/_____/_______', alignment: 'Left', fontSize: 9, border: [false, false, false, false] },
                { text: 'Local de Entrega ______________________________________________',
                   alignment: 'left', border: [false, false, false, false],  fontSize: 9 },
              ],  
            ]
          },
        },
     ],
    };
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  
    pdfDocGenerator.open();
}
export default PDFTalao;